import {
  useMutation,
  useQueryClient,
} from '@tanstack/react-query';
import { type Course } from './Course.tsx'
import { appelerApi, verifier, CLE_TABLE_COURSES } from './api.ts'

// Ajout d'une course propre a l'utilisateur (POST /api/events).
export default function useCreateCourse() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (course: Course) => {
      const response = await verifier(await appelerApi('/api/events', 'POST', course), [201]);
      return (await response.json()) as Course;
    },
    onSettled: () => queryClient.invalidateQueries({ queryKey: CLE_TABLE_COURSES }),
  });
}
